import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "inlineStyles", "testId", "isRanking", "innerRef", "isSortable", "onClick"];
// Delete this file when cleaning up platform-component-visual-refresh FG
import React from 'react';
import { HeadCell } from '../styled/table-head';
var TableHeadCellOld = function TableHeadCellOld(_ref) {
  var content = _ref.content,
    inlineStyles = _ref.inlineStyles,
    testId = _ref.testId,
    isRanking = _ref.isRanking,
    innerRef = _ref.innerRef,
    isSortable = _ref.isSortable,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(HeadCell
  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
  , _extends({
    style: inlineStyles,
    testId: testId && "".concat(testId, "--head--cell"),
    ref: typeof innerRef !== 'string' ? innerRef : null // string refs must be discarded as LegacyRefs are not compatible with FC forwardRefs
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, rest, {
    onClick: onClick,
    isSortable: isSortable
  }), isSortable ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-roledescription": "Sort button"
  }, content) : content);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default TableHeadCellOld;